var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1808 5.26316C14.1808 7.06535 12.7198 8.52632 10.9176 8.52632C9.11541 8.52632 7.65444 7.06535 7.65444 5.26316C7.65444 3.46097 9.11541 2 10.9176 2C12.7198 2 14.1808 3.46097 14.1808 5.26316ZM16.1808 5.26316C16.1808 8.16992 13.8244 10.5263 10.9176 10.5263C8.01084 10.5263 5.65444 8.16992 5.65444 5.26316C5.65444 2.3564 8.01084 0 10.9176 0C13.8244 0 16.1808 2.3564 16.1808 5.26316ZM10.9176 13.5789C14.9141 13.5789 17.9484 15.6122 19.0136 18H2.82162C3.88675 15.6122 6.92111 13.5789 10.9176 13.5789ZM19.4439 18H19.4429C19.4477 17.9991 19.4483 18 19.4439 18ZM2.39228 18H2.39128C2.3869 18 2.38746 17.9991 2.39228 18ZM10.9176 11.5789C5.95297 11.5789 1.79108 14.3285 0.681497 18.0279C0.364168 19.0859 1.28671 20 2.39128 20H19.4439C20.5485 20 21.471 19.0859 21.1537 18.0279C20.0441 14.3285 15.8822 11.5789 10.9176 11.5789Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.4ed9f117b85d42cd02de6153671b7ddc.svg";
export { ForwardRef as ReactComponent };